module.exports = __webpack_public_path__ + "static/washxpress-79b640445a47d0db4aa7c5c8f3c3707a.svg";